export default "__VITE_ASSET__Bg_ZKhgu__"